// extracted by mini-css-extract-plugin
module.exports = {"container":"Sx-z","copyContainer":"Tx-z"};